/* eslint-disable */
import React, {
  useEffect,
  useState,
  useMemo,
  useContext,
  useCallback,
} from "react";
import { Link } from "react-router-dom";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { MaterialReactTable } from "material-react-table";
import { MenuItem, Box } from "@mui/material";

import { GlobalProvider } from "context/GlobalContext";

import { assetImages } from "constants";

import SaveEcosystemPopup from "../Popup/SaveEcosystemPopup";
import EcosystemFilterPopup from "../Popup/EcosystemFilterPopup";
import EcosystemHeader from "../Header/EcosystemHeader";
import { useTranslation } from "react-i18next";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

// Main component function for EcosystemBody
const EcosystemBody = () => {
  const token = localStorage.getItem("token");
  const savedEcosystemId = localStorage.getItem("ecosystem");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { t, i18n } = useTranslation();
  const { screenHeight } = useContext(GlobalProvider);

  const [ecosystemList, setEcosystemList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [ecosystemId, setEcosystemId] = useState(null);

  const [filterModuleName, setFilterModuleName] = useState("");
  const [filterModuleSlug, setFilterModuleSlug] = useState("");
  const [filterDateRange, setFilterDateRange] = useState("");

  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedEcosystemIds, setSelectedEcosystemIds] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Function to fetch all ecosystems
  const getAllEcosystems = useCallback(async () => {
    setRowSelection({});
    setSelectedEcosystemIds([]);

    try {
      setIsLoading(true);
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_ECOSYSTEM}`;

      if (filterDateRange !== "") {
        requestUrl += `&filterdates=${filterDateRange}`;
      }
      if (filterModuleName !== "") {
        requestUrl += `&filtername=${filterModuleName}`;
      }
      if (filterModuleSlug !== "") {
        requestUrl += `&filterslug=${filterModuleSlug}`;
      }

      const response = await getData(requestUrl);

      setIsLoading(false);
      if (response.status) {
        setMessageType("success");
        setEcosystemList(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      console.error("Error fetching all ecosystems:", error.message);
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  }, [token, filterDateRange, filterModuleName, filterModuleSlug]);

  // Function to fetch filtered ecosystems
  const getFilteredEcosystems = useCallback(async () => {
    try {
      setIsLoading(true);
      const requestUrl = `${url.API_BASE_URL}${url.API_GET_FILTERED_ECOSYSTEM}`;

      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","),
          };
        }
        return filter;
      });

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      setIsLoading(false);

      if (response.status) {
        setEcosystemList(response.data);
      }
    } catch (error) {
      console.error("Error fetching filtered ecosystems:", error.message);
    }
  }, [token, jsonFilterQuery]);

  // Function to handle bulk deletion of ecosystems
  const deleteBulkEcosystemHandler = useCallback(async () => {
    if (selectedEcosystemIds.length > 0) {
      try {
        const ecosystemListToBeDelete = ecosystemList.filter((item) =>
          selectedEcosystemIds.includes(item._id)
        );

        let apiData = {
          ecosystemlist: ecosystemListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_ECOSYSTEM;

        const response = await putData(requestURL, apiData);

        if (response.status) {
          setMessageType("success");
          setAlertMessage("Ecosystem deleted successfully");

          setTimeout(() => {
            setRowSelection({});
            setSelectedEcosystemIds([]);
            setEcosystemList((prevList) =>
              prevList.filter(
                (item) => !selectedEcosystemIds.includes(item._id)
              )
            );
          }, 1500);
        } else {
          setMessageType("error");
          setAlertMessage(response.message);
        }
      } catch (error) {
        console.error("Error deleting bulk ecosystems:", error.message);
        setMessageType("error");
        setAlertMessage(error.message);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select at least one ecosystem.");
    }
    setShowAlert(true);
  }, [selectedEcosystemIds, token, ecosystemList]);

  // Function to switch the active ecosystem
  const switchEcosystemHandler = useCallback(
    async (ecosystemId, slug) => {
      try {
        const ecosystemData = {
          ecosystemid: ecosystemId,
          ecosystemslug: slug,
        };

        const requestUrl = `${url.API_BASE_URL}${url.API_SWITCH_ECOSYSTEM}`;

        const response = await postData(requestUrl, ecosystemData);

        if (response.status) {
          localStorage.setItem("token", response.token);
          localStorage.setItem("userInfo", JSON.stringify(response.data));
          localStorage.setItem("userID", JSON.stringify(response.data._id));
          localStorage.setItem("ecosystem", response.ecosystemid);
          localStorage.setItem("ecosystemslug", response.ecosystemslug);
          localStorage.setItem("ecosystemlogo", response.ecosystemlogo);
          localStorage.setItem("moduleaccess", response.data.moduleaccessdata);

          window.location.reload();
        }
      } catch (error) {
        console.error("Error switching ecosystem:", error.message);
      }
    },
    [token]
  );

  // Function to reset filter data
  const resetFilterData = useCallback(() => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  }, []);

  // Function to handle actions after popup closes
  const afterPopupCLose = (data = []) => {
    setEcosystemList((prevList) => {
      let updatedList = [...prevList];

      data.forEach((newItem) => {
        const index = updatedList.findIndex(
          (oldItem) => oldItem._id === newItem._id
        );

        if (index !== -1) {
          updatedList[index] = newItem;
        } else {
          updatedList.unshift(newItem);
        }
      });

      updatedList.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

      return updatedList;
    });
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        size: 70,
        Cell: ({ row }) => {
          // Cell renderer for actions column
          return (
            <button
              className="action_btn_mui"
              data-bs-toggle="offcanvas"
              data-bs-target="#saveEcosystem"
              aria-controls="saveEcosystem"
              onClick={() => {
                setEcosystemId(row.original._id);
              }}
            >
              <span className="d-block material-symbols-outlined horz_icon">
                more_horiz
              </span>
            </button>
          );
        },
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        accessorKey: "name",
        header: t("Name"),
        size: 200,
        Cell: ({ row }) => {
          // Cell renderer for name column
          return (
            <div className="d-flex align-content-center gap-2">
              <span>{row.original.name}</span>
              {row.original._id === savedEcosystemId ? (
                <span className="icon-md material-symbols-outlined text-success">
                  check_circle
                </span>
              ) : null}
            </div>
          );
        },
      },
      {
        accessorKey: "*",
        header: t("Logo"),
        size: 150,
        Cell: ({ row }) => {
          // Cell renderer for logo column
          return (
            <Box>
              <img
                height={30}
                width={100}
                src={
                  row.original.logopath === ""
                    ? assetImages.blankLogo
                    : url.SERVER_URL + row.original.logopath
                }
                loading="lazy"
                style={{ borderRadius: "5%" }}
                alt={row.original.name + " logo"}
              />
            </Box>
          );
        },
      },
      {
        accessorKey: "slug",
        header: t("Slug"),
        size: 150,
      },
      {
        accessorKey: "feturedstring",
        header: t("Featured"),
        size: 180,
      },
      {
        accessorKey: "isdefaultstring",
        header: t("Is Default"),
        size: 180,
      },
      {
        accessorKey: "createddate",
        header: t("Date"),
        size: 140,
      },
      {
        accessorKey: "switchAction",
        header: t("Switch Ecosystem"),
        size: 250,
        Cell: ({ row }) => {
          // Cell renderer for switch ecosystem action
          return (
            <Link
              to="#"
              className="btn btn-outline-primary d-flex align-items-center justify-content-center gap-1"
              onClick={() =>
                switchEcosystemHandler(row.original._id, row.original.slug)
              }
            >
              <span className="d-block">{t("Switch")}</span>
              <span className="d-block material-symbols-outlined">
                chevron_right
              </span>
            </Link>
          );
        },
      },
    ],
    [i18n.language, savedEcosystemId, t, switchEcosystemHandler]
  );

  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getFilteredEcosystems();
    } else if (reloadData) {
      getAllEcosystems();
      setReloadData(false);
    }
  }, [jsonFilterQuery, reloadData, getFilteredEcosystems, getAllEcosystems]);

  useEffect(() => {
    getAllEcosystems();
  }, [getAllEcosystems]);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedEcosystemIds(selectedIdsArray);
  }, [rowSelection]);

  // Function to close the alert notification
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (userInfo.role.slug === "ADMIN" || userInfo.role.slug === "SUPER_ADMIN") {
    return (
      <div id="content_wrapper" className="ecosystem-body-wrapper">
        <section className="crm-wrapper bg-white pb-5 rounded-3 shadow-sm">
          <div className="container-fluid px-lg-5 py-4">
            <EcosystemHeader
              reloadList={resetFilterData}
              changeStatusHandler={deleteBulkEcosystemHandler}
            />

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={ecosystemList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder: initialColumnOrder }}
                  initialState={{
                    rowSelection,
                    columnOrder: initialColumnOrder,
                  }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50,
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                  enableColumnResizing
                  enableColumnActions
                  enableColumnFilters
                  enablePagination
                  enableSorting
                  enableBottomToolbar
                  enableTopToolbar
                />
              </div>
            )}
          </div>
        </section>

        <SaveEcosystemPopup
          afterPopupCLose={afterPopupCLose}
          ecosystemId={ecosystemId}
          setEcosystemId={setEcosystemId}
        />

        <EcosystemFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={resetFilterData}
          moduleSlug="ecosystemlist"
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default EcosystemBody;
